import { useSuspenseQuery, queryOptions } from '@tanstack/react-query';
import { api } from '@/lib/api-client';
import { QueryConfig } from '@/lib/tanstack-query';
import { Sale } from '@/types/api/sale';
import z from 'zod';

export const GetSaleSortKeySchema = z.enum(['name', 'createdAt', 'updatedAt']);
export const GetSaleIncludeKey = z.enum(['products']);

export const GetSaleParamsSchema = z
  .object({
    include: z.array(GetSaleIncludeKey),
  })
  .partial();

export type GetSaleParams = z.infer<typeof GetSaleParamsSchema>;

export const getSale = async ({ saleId, params }: { saleId: string; params?: GetSaleParams }): Promise<Sale> => {
  return (await api.get(`/sales/${saleId}`, { params })).data;
};

export const getSaleQueryOptions = (saleId: string, params: GetSaleParams = {}) => {
  return queryOptions({
    queryKey: ['sales', saleId, params],
    queryFn: () => getSale({ saleId, params }),
  });
};

type UseSaleOptions = {
  saleId: string;
  params?: GetSaleParams;
  queryConfig?: QueryConfig<typeof getSaleQueryOptions>;
};

export const useSaleSuspense = ({ saleId, queryConfig, params }: UseSaleOptions) => {
  return useSuspenseQuery({
    ...getSaleQueryOptions(saleId, params),
    ...queryConfig,
  });
};
